// Curated lucide-react icon names (kebab-case) for form-builder pickers.
// Resolved at render time by DynamicIcon (lucide-icon.tsx).

export const FORM_GROUP_ICONS: string[] = [
  'user-circle',
  'users',
  'stethoscope',
  'heart-pulse',
  'activity',
  'clipboard-list',
  'clipboard-plus',
  'file-text',
  'folder',
  'hospital',
  'pill',
  'syringe',
  'test-tube',
  'test-tubes',
  'microscope',
  'flask-conical',
  'dna',
  'bone',
  'brain',
  'heart',
  'thermometer',
  'bandage',
  'cross',
  'shield-plus',
  'baby',
  'calendar-days',
  'bar-chart-3',
  'line-chart',
  'notebook-pen',
  'scan-line',
]

export const FORM_ICONS: string[] = [
  'file-text',
  'file-plus',
  'file-edit',
  'clipboard-list',
  'clipboard-check',
  'notebook-pen',
  'stethoscope',
  'heart-pulse',
  'pill',
  'syringe',
  'test-tube',
  'microscope',
  'activity',
  'thermometer',
  'bandage',
  'scan-line',
  'calendar-days',
  'bar-chart-3',
]

export const PROJECT_ICONS: string[] = [
  'activity',
  'heart',
  'heart-pulse',
  'brain',
  'stethoscope',
  'pill',
  'syringe',
  'microscope',
  'test-tube',
  'test-tubes',
  'dna',
  'flask-conical',
  'bandage',
  'eye',
  'ear',
  'bone',
  'baby',
  'users',
  'user-circle',
  'clipboard-list',
  'file-text',
  'folder',
  'building-2',
  'hospital',
  'cross',
  'shield-plus',
  'book-open',
  'graduation-cap',
  'beaker',
  'atom',
  'thermometer',
  'droplet',
  'zap',
  'sparkles',
  'star',
  'target',
  'flag',
  'bookmark',
  'database',
  'bar-chart-3',
  'line-chart',
  'pie-chart',
  'calendar-days',
  'scan-line',
]

export const DEFAULT_GROUP_ICON = 'folder'
export const DEFAULT_FORM_ICON = 'file-text'
export const DEFAULT_PROJECT_ICON = 'folder'
